import {
  Box,
  Flex,
  HStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Select,
  Text,
  Badge,
  useDisclosure,
} from "@chakra-ui/react";
import { RiUserLine } from "react-icons/ri";
import { HiSpeakerphone } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { openUserDataModel } from "../../../modules/admin-modules/models/Actions";
import { logoutUserAction } from "../../../modules/auth/Actions";

import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import logout from "../../../assets/icons/logout.svg";
import { onLanguageHandle } from "../../../helpers/language";
import { getNotificationsRequest } from "../../../modules/user/Actions";
import { getActiveAnnouncementsRequest } from "../../../modules/students-modules/announcements/Actions";
import AnnouncementsCarousel from "../../../components/student/AnnouncementsCarousel";
import MobileNavbar from "./mobileNavbar";
import Notifications from "./notifications";

const Navbar = ({ color, bg, t, i18n }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData, notifications } = useSelector((state) => state.user);
  const announcements = useSelector((state) => state.studentAnnouncements.announcements);
  const { isOpen: isAnnouncementsOpen, onOpen: onAnnouncementsOpen, onClose: onAnnouncementsClose } = useDisclosure();

  useEffect(() => {
    dispatch(getNotificationsRequest(userData?.phone));
    dispatch(getActiveAnnouncementsRequest());
  }, [userData, dispatch]);

  console.log(notifications);
  window.onscroll = function () {
    scrollFn();
  };
  function scrollFn() {
    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      document.getElementById("navbar").style.backgroundColor = "white";
    } else {
      document.getElementById("navbar").style.backgroundColor = "";
    }
  }

  return (
    <Flex
      id="navbar"
      position={"fixed"}
      zIndex="100"
      alignItems="center"
      justifyContent="space-between"
      top="0"
      p="5px"
      w="100%"
      color={color}
      bg={bg}
      h="75px"
      textTransform={"capitalize"}
    >
      <Box w={"fit-content"}>
        <Image
          src={require("../../../assets/logo.png")}
          w="200px"
          id="logo"
          h="auto"
          mx="-10px"
          onClick={() => navigate("/home")}
        />{" "}
      </Box>
      <HStack
        spacing="20px"
        display={{ base: "none", md: "flex" }}
        fontSize="16px"
        fontWeight="400"
      >
        <Link to={"/home"}>
          <Text
            _hover={{ color: "main_2" }}
            textDecoration={
              window.location.pathname == "/home" ? "underline" : "none"
            }
            fontWeight={window.location.pathname == "/home" ? "600" : "400"}
            color={window.location.pathname == "/home" ? "main_2" : "black"}
          >
            {t("components.home_navbar.home")}
          </Text>
        </Link>

        <Link to={"/videos/sections"}>
          <Text
            _hover={{ color: "main_2" }}
            textDecoration={
              window.location.pathname.includes("videos") ||
              window.location.pathname.includes("video")
                ? "underline"
                : "none"
            }
            fontWeight={
              window.location.pathname.includes("videos") ||
              window.location.pathname.includes("video")
                ? "600"
                : "400"
            }
            color={
              window.location.pathname.includes("videos") ||
              window.location.pathname.includes("video")
                ? "main_2"
                : "black"
            }
          >
            {t("components.home_navbar.videos")}
          </Text>
        </Link>
        <Link to={"/model-answers/chapters"}>
          <Text
            _hover={{ color: "main_2" }}
            textDecoration={
              window.location.pathname.includes("model-answer") ||
              window.location.pathname.includes("model-answers")
                ? "underline"
                : "none"
            }
            fontWeight={
              window.location.pathname.includes("model-answer") ||
              window.location.pathname.includes("model-answers")
                ? "600"
                : "400"
            }
            color={
              window.location.pathname.includes("model-answer") ||
              window.location.pathname.includes("model-answer")
                ? "main_2"
                : "black"
            }
          >
            {t("components.home_navbar.pdf")}
          </Text>
        </Link>
        <Link to={"/homeworks/sections"}>
          <Text
            _hover={{ color: "main_2" }}
            textDecoration={
              window.location.pathname.includes("homeworks") ||
              window.location.pathname.includes("homework")
                ? "underline"
                : "none"
            }
            fontWeight={
              window.location.pathname.includes("homeworks") ||
              window.location.pathname.includes("homework")
                ? "600"
                : "400"
            }
            color={
              window.location.pathname.includes("homeworks") ||
              window.location.pathname.includes("homework")
                ? "main_2"
                : "black"
            }
          >
            {t("components.home_navbar.homework")}
          </Text>
        </Link>
        <Link to={"/exams/sections"}>
          <Text
            _hover={{ color: "main_2" }}
            textDecoration={
              !window.location.pathname.includes("student") &&
              (window.location.pathname.includes("exams") ||
                window.location.pathname.includes("exam"))
                ? "underline"
                : "none"
            }
            fontWeight={
              !window.location.pathname.includes("student") &&
              (window.location.pathname.includes("exams") ||
                window.location.pathname.includes("exam"))
                ? "600"
                : "400"
            }
            color={
              !window.location.pathname.includes("student") &&
              (window.location.pathname.includes("exams") ||
                window.location.pathname.includes("exam"))
                ? "main_2"
                : "black"
            }
          >
            {t("components.home_navbar.exams")}
          </Text>
        </Link>
        <Link to={"/asquera-practice"}>
          <Text
            _hover={{ color: "main_2" }}
            textDecoration={
              window.location.pathname.includes("asquera-practice")
                ? "underline"
                : "none"
            }
            fontWeight={
              window.location.pathname.includes("asquera-practice")
                ? "600"
                : "400"
            }
            color={
              window.location.pathname.includes("asquera-practice")
                ? "main_2"
                : "black"
            }
          >
            {t("components.home_navbar.asquera_practice")}
          </Text>
        </Link>
        <Link to={"/questions"}>
          <Text
            _hover={{ color: "main_2" }}
            textDecoration={
              window.location.pathname.includes("Missed") ? "underline" : "none"
            }
            fontWeight={
              window.location.pathname.includes("Missed") ? "600" : "400"
            }
            color={
              window.location.pathname.includes("Missed") ? "main_2" : "black"
            }
          >
            {t("components.home_navbar.missed_questions")}
          </Text>{" "}
        </Link>

        {/* <Link to={"/performance-report"}>
          <Text
            _hover={{ color: "main_2" }}
            textDecoration={
              window.location.pathname.includes("Missed") ? "underline" : "none"
            }
            fontWeight={
              window.location.pathname.includes("Missed") ? "600" : "400"
            }
            color={
              window.location.pathname.includes("Missed") ? "main_2" : "black"
            }
          >
            Performance Report
          </Text>
        </Link> */}
        <Link to={"/student/exams"}>
          <Text
            _hover={{ color: "main_2" }}
            textDecoration={
              window.location.pathname.includes("student") &&
              window.location.pathname.includes("exams")
                ? "underline"
                : "none"
            }
            fontWeight={
              window.location.pathname.includes("student") &&
              window.location.pathname.includes("exams")
                ? "600"
                : "400"
            }
          >
            {t("components.home_navbar.student_exams")}
          </Text>
        </Link>

        {/* <Text _hover={{ color: "main_2" }}>
          {t("student_navbar.summaries")}
        </Text>

        <Text _hover={{ color: "main_2" }}>
          {t("student_navbar.liveVideos")}
        </Text>

        <Text _hover={{ color: "main_2" }}>
          {t("student_navbar.studyWithasquera")}
        </Text> */}
      </HStack>

      <HStack display={{ base: "none", md: "flex" }} mx={2}>
        <Select
          dir={localStorage.getItem("language") == "ar" ? "rtl" : "ltr"}
          variant="unstyled"
          width="120px"
          color="main_2"
          value={localStorage.getItem("lang") || "en"}
          onChange={(e) => onLanguageHandle(e.target.value, i18n)}
        >
          <option style={{ textAlign: "center" }} value="ar">
            عربي
          </option>
          <option value="en" style={{ textAlign: "center" }}>
            En
          </option>
        </Select>
        {/* Announcements Button */}
        {announcements && announcements.length > 0 && (
          <Box position="relative">
            <IconButton
              aria-label="View Announcements"
              icon={<HiSpeakerphone fontSize="20px" />}
              variant="outline"
              borderColor="main_2"
              color="#f7d723"
              onClick={onAnnouncementsOpen}
              _hover={{ bg: "main_2", color: "white" }}
            />
            <Badge
              position="absolute"
              top="-8px"
              right="-8px"
              borderRadius="full"
              bg="red.500"
              color="white"
              fontSize="10px"
              minW="18px"
              h="18px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {announcements.length}
            </Badge>
          </Box>
        )}
        <Menu direction="rtl">
          <MenuButton
            _focus={{ outline: "none" }}
            as={IconButton}
            borderColor="main_2"
            aria-label="Options"
            icon={<RiUserLine color="#f7d723" fontSize="20px" />}
            variant="outline"
          />
          <MenuList dir="rtl">
            <MenuItem p="7px" mt="10px">
              <HStack spacing="7px">
                <Text mx="5px">{userData?.name}</Text>
              </HStack>
            </MenuItem>
            <MenuItem p="7px" mt="10px">
              <HStack spacing="7px">
                <Text mx="5px">{userData?.phone} </Text>
              </HStack>
            </MenuItem>
            <MenuItem p="7px" mt="10px">
              <HStack spacing="7px">
                <Text mx="5px">{userData?.grade?.name} </Text>
              </HStack>
            </MenuItem>
            <MenuItem
              p="7px"
              mt="10px"
              onClick={() => dispatch(openUserDataModel())}
            >
              <HStack spacing="7px">
                <Text mx="5px">QR Code</Text>
              </HStack>
            </MenuItem>
            <MenuDivider />

            <MenuItem
              p="7px"
              mt="10px"
              onClick={() => dispatch(logoutUserAction())}
            >
              <HStack spacing="7px">
                <Image src={logout} minW="15px" />
                <Text mx="5px">تسجيل الخروج</Text>
              </HStack>
            </MenuItem>
          </MenuList>
        </Menu>
        <Notifications notifications={notifications} />
      </HStack>

      <Box display={{ base: "flex", md: "none" }} alignItems="center">
        <MobileNavbar />
        {/* Announcements Button for Mobile */}
        {announcements && announcements.length > 0 && (
          <Box position="relative" mr={2}>
            <IconButton
              aria-label="View Announcements"
              icon={<HiSpeakerphone fontSize="18px" />}
              variant="outline"
              borderColor="main_2"
              color="#f7d723"
              onClick={onAnnouncementsOpen}
              size="sm"
              _hover={{ bg: "main_2", color: "white" }}
            />
            <Badge
              position="absolute"
              top="-6px"
              right="-6px"
              borderRadius="full"
              bg="red.500"
              color="white"
              fontSize="9px"
              minW="16px"
              h="16px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {announcements.length}
            </Badge>
          </Box>
        )}
        <Select
          dir={localStorage.getItem("language") == "ar" ? "rtl" : "ltr"}
          variant="unstyled"
          width="120px"
          color="main_2"
          value={localStorage.getItem("lang") || "en"}
          onChange={(e) => onLanguageHandle(e.target.value, i18n)}
        >
          <option style={{ textAlign: "center" }} value="ar">
            عربي
          </option>
          <option value="en" style={{ textAlign: "center" }}>
            En
          </option>
        </Select>
        <Notifications notifications={notifications} />
      </Box>

      {/* Announcements Carousel Modal */}
      <AnnouncementsCarousel
        announcements={announcements}
        isOpen={isAnnouncementsOpen}
        onClose={onAnnouncementsClose}
      />
    </Flex>
  );
};

export default withTranslation()(Navbar);
